__turbopack_context__.v({
  "arrow": "p7tODG_arrow",
  "askAi": "p7tODG_askAi",
  "askAiIcon": "p7tODG_askAiIcon",
  "avatar": "p7tODG_avatar",
  "contentWrapper": "p7tODG_contentWrapper",
  "foundItem": "p7tODG_foundItem",
  "foundItemHost": "p7tODG_foundItemHost",
  "foundItemLink": "p7tODG_foundItemLink",
  "header": "p7tODG_header",
  "headerAskable": "p7tODG_headerAskable",
  "list": "p7tODG_list",
  "matchRow": "p7tODG_matchRow",
  "matchType": "p7tODG_matchType",
  "matches": "p7tODG_matches",
  "name": "p7tODG_name",
  "postDetails": "p7tODG_postDetails",
  "text": "p7tODG_text",
  "type": "p7tODG_type",
});
